import { createDraft } from "../requests/createDraft"
import { cancelDraft } from "../requests/cancelDraft"
import { completeDraft } from "../requests/completeDraft"
import { getDraftStatus } from "../requests/getDraftStatus"
import { getPurchaseDetails } from "../requests/getPurchaseDetails"
import { patchPurchaseDocuments } from "../requests/patchPurchaseDocuments"

const purchaseDraftAndCompletionPageContent = [
  {
    "type": "title",
    "content": "Purchase draft & completion"
  },
  {
    "type": "subtitle",
    "content": "Create a purchase draft to compute final pricing, and retrieve product documents. Drafts remain pending until you complete or cancel them."
  },
  {
    type: "text",
    content: `
A purchase draft represents a pending insurance purchase. It allows you to compute final pricing, retrieve product documents, and prepare for payment without immediately completing the purchase.

Drafts can be created via the API by providing necessary details such as selected product and customer information. Once a draft is created, you can check its status to see if it's still pending or if any additional actions are required.

To finalize the purchase, you can either complete the draft (which processes the payment and issues the insurance) or cancel it (which voids the draft without any charges).
    `
  },
  {
    "type": "text",
    "content": "Note that hosted payment drafts must be finalized by sending customers to the hosted_payment_url; non-hosted drafts must be completed or cancelled via the API."
  },
  {
    "type": "separator"
  },
  {
    ...createDraft,
    anchor: "create"
  },
  {
    ...getDraftStatus,
    anchor: "status"
  },
  {
    ...completeDraft,
    anchor: "complete"
  },
  {
    ...cancelDraft,
    anchor: "cancel"
  },
  {
    ...getPurchaseDetails,
    anchor: "purchase-details"
  },
  {
    ...patchPurchaseDocuments,
    anchor: "patch-documents"
  }
]
export default purchaseDraftAndCompletionPageContent
